<template>
  <div class="tableWrap">
    <div
      class="table-top-bar"
      v-show="!selectedRowScopes.length"
    >
      <div class="leftBar">
        <CreateButton />
      </div>
      <filter-panel
        :init-data="initData"
        :params="params"
        :filter-show="filterShow"
        :cus-filter-list="cusFilterList"
        :filter-list="filterList"
        :filter-id="filterId"
        :filter-icon="filterIcon"
        :level="level"
        @filter-command="handleFilterCommand"
        @save-filter-search="handleSaveFilterSearch"
        @delete-filter-group="deleFilterGroup"
        @delete-filter-tag="handleDeleteFilterTag"
        @add-tag="addTag"
        @close-my-filter="closeMyFilter"
        @operator-change="operatorChange"
        @value-change="valueChange"
        @save-filter-show="saveFilterShow = $event"
        @delete-filter-obj="deleFilterObj"
        @add-filter-item="addFilterItem"
        @field-change="handleFieldChange"
      ></filter-panel>
      <div
        class="rightTools"
        :style="{ flex: searchInput ? '260px 0 0' : '100px 0 0' }"
      >
        <div class="searchInput">
          <el-input
            clearable
            placeholder="请输入内容"
            v-model="params.keyword"
            class="input-with-select"
            v-if="searchInput"
            @change="keywordChange"
          ></el-input>
          <el-button
            type="text"
            icon="el-icon-search"
            @click="searchInput = !!params.keyword || !searchInput"
          ></el-button>
        </div>
        <div class="tools">
          <div class="toolsItem">
            <el-tooltip
              class="item"
              effect="dark"
              content="定制列"
              placement="top"
            >
              <cusColumns
                sysType="GOOGLE_ASSIST"
                :defaultKeys="defaultFields"
                @getCurrentColumn="getCurrentColumn"
              >
                <el-button
                  type="text"
                  class="el-icon-s-grid"
                ></el-button>
              </cusColumns>
            </el-tooltip>
          </div>
          <!-- <div class="downLoad">
            <down-load
              :downLoadParams="{ ...downLoadParams, ids: [] }"
            ></down-load>
          </div> -->
        </div>
      </div>
    </div>
    <div>
      <div
        class="toolsBar"
        v-show="selectedRowScopes.length"
      >
        <div class="toolsCon">
          <p>已选{{ selectedRowScopes.length }}项</p>
          <div class="operate-btn">
            <el-button
              type="primary"
              plain
              size="mini"
              :disabled="mutateStatusLoading"
              @click="setStatus(false, 'ENABLED')"
            >
              启动
            </el-button>
          </div>

          <div class="operate-btn">
            <el-button
              type="primary"
              plain
              size="mini"
              :disabled="mutateStatusLoading"
              @click="setStatus(false, 'PAUSED')"
            >
              暂停
            </el-button>
          </div>
          <div class="operate-btn">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="setClockTime(1)"
            >
              定时开启
            </el-button>
          </div>
          <div class="operate-btn">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="setClockTime(4)"
            >
              定时关闭
            </el-button>
          </div>
          <!-- <div class="operate-btn">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="handleEditCommand({ type: 'adsets' })"
              v-if="selectedRowScopes.find((v) => v.level == 'adset')"
            >
              编辑
            </el-button>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="handleEditCommand({ type: 'editAds' })"
              v-if="selectedRowScopes.find((v) => v.level == 'ad')"
            >
              编辑
            </el-button>
          </div> -->
          <!-- <div class="operate-btn">
            <el-dropdown
              trigger="click"
              @command="handleEditCommand"
              placement="bottom"
            >
              <el-button type="primary" plain size="mini">批量操作</el-button>
              <el-dropdown-menu
                slot="dropdown"
                style="width: 260px"
              >
                <el-dropdown-item
                  disabled
                  style="font-size: 12px"
                >
                  <div class="columnName">
                    <span>广告系列</span>
                    <div>
                      已选
                      {{ campaignCount }}
                      项
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'campaign' }"
                  :disabled="!campaignCount"
                >
                  修改预算与竞价
                </el-dropdown-item>
                <el-dropdown-item
                  disabled
                  style="font-size: 12px"
                >
                  <div class="columnName">
                    <span> 广告组 </span>
                    <div>已选{{ adsetCount }}项</div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'adset' }"
                  :disabled="!adsetCount"
                >
                  修改预算与竞价
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'adsetPix' }"
                  :disabled="!adsetCount"
                >
                  批量修改像素
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'adsetName' }"
                  :disabled="!adsetCount"
                >
                  批量修改广告组名称
                </el-dropdown-item>
                <el-dropdown-item
                  disabled
                  style="font-size: 12px"
                >
                  <div class="columnName">
                    <span>广告</span>
                    <div>
                      已选
                      {{ adCount }}
                      项
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'adName' }"
                  :disabled="!adCount"
                >
                  批量修改广告名称
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'adUrl' }"
                  :disabled="!adCount"
                >
                  批量添加广告网域
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'editPages' }"
                  :disabled="!adCount"
                >
                  批量编辑广告主页
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
          <!-- <div class="operate-btn">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="f_copy"
            >
              快速复制
            </el-button>
          </div> -->
          <div class="operate-btn">
            <el-button
              type="primary"
              plain
              size="mini"
              :disabled="mutateStatusLoading"
              @click="setStatus(false, 'REMOVED')"
            >
              删除
            </el-button>
          </div>
        </div>
        <div class="close">
          <i
            class="el-icon-close"
            @click="clearIds"
          ></i>
        </div>
      </div>
    </div>
    <!--  v-loading="loading" -->
    <el-table
      class="my-table"
      :data="tableData"
      :row-key="getRowKey"
      :lazy="lazy"
      :load="loadChildren"
      border
      ref="table"
      :default-sort="{ prop: 'effective_status', order: 'ascending' }"
      show-summary
      :summary-method="getSummaries"
      stripe
      empty-text="暂无数据，选择账号进行查询~"
      width="100%"
      v-loading="tableLoading"
      @selection-change="handleSelectionChange"
      @expand-change="expandChange"
      @sort-change="sortChange"
    >
      <el-table-column
        v-if="level !== 'asset'"
        type="selection"
        fixed
      ></el-table-column>

      <el-table-column
        prop="name"
        label="名称"
        width="360"
        sortable="custom"
        fixed
        v-if="level !== 'asset'"
      >
        <template slot-scope="scope">
          <ad-cell-name
            :level="level"
            :value="scope"
            :disabled="disAbled"
            :account-id="accountId"
            @scope-row-changed="refreshTableRow(scope)"
            @setStatus="setStatus"
            @copy="copyRow"
            @handle-edit-command="handleEditCommand"
            @open-next-level="openNextLevel"
            @operation-log="operationLog"
          ></ad-cell-name>
        </template>
      </el-table-column>
      <el-table-column
        prop="effective_status"
        label="状态"
        width="210"
        sortable="custom"
        v-if="level !== 'asset'"
      >
        <template #header>
          <div class="statusHeader inline-block">
            <span>状态</span>
            <div
              @click.stop
              style="display: inline-block"
            >
              <el-popover
                v-if="initData && initData.FilteringStatus"
                placement="bottom"
                width="80"
                trigger="click"
              >
                <el-checkbox-group
                  v-model="checkList"
                  class="toolsCheckTips"
                  @change="selectStatus"
                >
                  <el-checkbox
                    :label="checkbox.key"
                    v-for="checkbox in initData.FilteringStatus || []"
                    :key="checkbox.key"
                  >
                    {{ checkbox.desc }}
                  </el-checkbox>
                </el-checkbox-group>
                <i
                  slot="reference"
                  class="el-icon-discount"
                ></i>
              </el-popover>
            </div>
          </div>
        </template>
        <template
          slot-scope="scope"
          v-if="scope.row.status"
        >
          <status-cell
            :row="scope.row"
            :init-data="initData"
            @open-ai-suggestion="openAiSuggestion"
            @review-score="reviewScore"
          ></status-cell>
        </template>
      </el-table-column>
      <!-- 素材资源固定列 - 仅 asset 层级显示 -->
      <el-table-column
        prop="asset_resource"
        label="素材资源"
        width="360"
        fixed
        v-if="level === 'asset'"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.asset_resource">
            <!-- 视频类型 -->
            <div
              v-if="scope.row.asset_resource.youtube_video_id"
              class="flex items-center"
            >
              <el-image
                :src="scope.row.asset_resource.thumbnail"
                style="width: 60px; height: 45px; flex-shrink: 0"
                fit="cover"
              ></el-image>
              <span
                class="ml-2 ellipsis-1"
                :title="scope.row.asset_resource.youtube_video_title"
              >
                {{ scope.row.asset_resource.youtube_video_title }}
              </span>
            </div>
            <!-- 图片类型 -->
            <div
              v-else-if="scope.row.asset_resource.url"
              class="flex items-center"
            >
              <el-image
                :src="scope.row.asset_resource.url"
                style="width: 60px; height: 60px; flex-shrink: 0"
                fit="cover"
                :preview-src-list="[scope.row.asset_resource.url]"
              ></el-image>
              <span class="ml-2 text-xs text-gray-500">
                {{ scope.row.asset_resource.width }}x{{ scope.row.asset_resource.height }}
              </span>
            </div>
            <!-- 文本类型 -->
            <div
              v-else-if="scope.row.asset_resource.text"
              class="ellipsis-1"
              :title="scope.row.asset_resource.text"
            >
              {{ scope.row.asset_resource.text }}
            </div>
            <span v-else>--</span>
          </div>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="campaign_ref"
        label="是否关联商品"
        width="120"
        v-if="level == 'campaign'"
      >
        <template slot-scope="scope">
          <related-product-cell
            :row="scope.row"
            :user-info="userInfo"
            @relate-sale-click="relateSaleClick"
          ></related-product-cell>
        </template>
      </el-table-column>
      <!-- 其它非固定字段 -->
      <template v-for="(item, index) in currentShowColumnList">
        <!-- 多级表头 -->
        <el-table-column
          v-if="item.children && item.children.length"
          :label="item.filedName"
          :width="columnWidth(item)"
          header-align="center"
        >
          <template #header>
            <span>
              <el-popover
                placement="bottom"
                :title="item.filedName"
                width="460"
                trigger="hover"
                :content="item.remark"
                :disabled="!item.remark"
              >
                <span
                  class="reference"
                  slot="reference"
                  >{{ item.filedName }}</span
                >
              </el-popover>
            </span>
          </template>
          <!-- 子级列 -->
          <el-table-column
            v-for="(child, childIndex) in item.children"
            :key="childIndex"
            :prop="child.filedKey"
            :label="child.filedName"
            :width="columnWidth(child)"
            :sortable="child.hasSort"
            :align="child.filedKey == 'budget' || child.filedKey == 'product_report' ? '' : 'right'"
            header-align="left"
          >
            <template #header>
              <span>
                <el-popover
                  placement="bottom"
                  :title="child.filedName"
                  width="460"
                  trigger="hover"
                  :content="child.remark"
                  :disabled="!child.remark"
                >
                  <span
                    class="reference"
                    slot="reference"
                    >{{ child.filedName }}</span
                  >
                </el-popover>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ formatedCellValueV2(scope.row, child) }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- 单级表头 -->
        <el-table-column
          v-else
          :prop="item.filedKey"
          :label="item.filedName"
          :width="columnWidth(item)"
          :sortable="item.supportSort"
          :align="item.filedKey == 'budget' || item.filedKey == 'product_report' ? '' : 'right'"
          header-align="left"
        >
          <template #header>
            <span>
              <el-popover
                placement="bottom"
                :title="item.filedName"
                width="460"
                trigger="hover"
                :content="item.remark"
                :disabled="!item.remark"
              >
                <span
                  class="reference"
                  slot="reference"
                  >{{ item.filedName }}</span
                >
              </el-popover>
            </span>
          </template>
          <template slot-scope="scope">
            <!-- 广告系列预算 -->
            <ad-cell-inline-edit-budget
              :value="scope"
              :accountId="accountId"
              @scope-row-changed="refreshTableRow(scope)"
              :key="scope.row.id"
              v-if="item.filedKey === 'budget'"
              :date-range="dateRange"
              @get-list="debouncedReloadTable"
              @settingComplete="settingComplete"
            ></ad-cell-inline-edit-budget>
            <div v-else-if="item.filedKey === 'bid'">
              <!-- 需求开发目标出价 -->
              <Ad-cell-inline-edit-target-cp
                v-if="
                  (scope.row.level == 'campaign' && scope.row.type == 'DEMAND_GEN') ||
                  (scope.row.level == 'adset' && scope.row.campaign_type == 'DEMAND_GEN')
                "
                :value="scope"
                :accountId="accountId"
                :level="scope.row.level"
                :userInfo="userInfo"
                @scope-row-changed="refreshTableRow(scope)"
                :key="scope.row.id"
                @settingComplete="settingComplete"
                @get-list="debouncedReloadTable"
              ></Ad-cell-inline-edit-target-cp>
              <!-- 搜索广告出价 -->
              <AdCellSearchBid
                v-if="
                  (scope.row.level == 'campaign' && scope.row.type == 'SEARCH') ||
                  (scope.row.level == 'adset' && scope.row.campaign_type == 'SEARCH')
                "
                :value="scope"
                :accountId="accountId"
                :level="scope.row.level"
                :userInfo="userInfo"
                @scope-row-changed="refreshTableRow(scope)"
                :key="scope.row.id"
                @settingComplete="settingComplete"
                @get-list="debouncedReloadTable"
              />
            </div>
            <div v-else-if="item.filedKey === 'adProductReport'">
              <!-- tab切换-商品经营分析/广告系列经营分析（默认广告系列经营分析）-->
              <adCellProductReport
                :adProductReport="scope.row.adProductReport"
                :level="scope.row.level"
                :campaignId="scope.row.campaign_id + ''"
                :adAccountId="scope.row.ad_accountId + ''"
                :currency_sign="scope.row.currency"
                :key="scope.row.level + scope.row.id + scope.row.name"
                platform="google"
                :dateRange="dateRange.dateRange"
              ></adCellProductReport>
            </div>
            <!-- 定时 -->
            <div v-else-if="item.filedKey === 'open_schedule'">
              <!-- tab切换-商品经营分析/广告系列经营分析（默认广告系列经营分析）-->
              <open-schedule
                :scope="scope"
                :key="scope.row.level + scope.row.id + scope.row.name"
                :level="level"
                @setCurrentRow="setCurrentRow"
              ></open-schedule>
            </div>
            <!-- 广告类型 -->
            <div v-else-if="item.filedKey === 'type' || item.filedKey === 'campaign_type'">
              <ad-type-cell
                :row="scope.row"
                :level="level"
                :types-list="typesList"
              ></ad-type-cell>
            </div>
            <div v-else-if="item.filedKey === 'local_order'">
              <div
                v-if="scope.row._localOrderLoading"
                class="local-order-loading"
              >
                <i class="el-icon-loading"></i>
              </div>
              <localOrder
                v-else
                :id="scope.row.id + ''"
                :level="scope.row.level"
                :row="{
                  ad: {
                    adAccountId: scope.row?.ad_accountId,
                    campaignId: scope.row?.campaign_id,
                    adGroupId: scope.row?.group_id,
                  },
                  ...scope.row?.local_order,
                }"
                :disabled="!!!scope.row?.local_order"
                :api="getLocalOrderStatApi"
                :params="{
                  dateStart: params.date_start,
                  dateEnd: params.date_end,
                  adsetCmapaignIdMap:
                    scope.row?.level === 'adset' && scope.row?.group_id && scope.row?.campaign_id
                      ? { [scope.row.group_id]: scope.row.campaign_id }
                      : null,
                }"
                platform="google"
              >
                <div
                  v-if="scope.row.local_order"
                  :class="[
                    !(scope.row?.local_order?.validOrderCount && scope.row?.local_order?.orderCount)
                      ? 'lightColor'
                      : '',
                  ]"
                >
                  <p>
                    {{ `${Number(scope.row.local_order.validOrderCount)}/${Number(scope.row.local_order.orderCount)}` }}
                  </p>
                  <p
                    class="color9"
                    style="height: 20px; line-height: 20px"
                    v-if="scope.row.spend && scope.row.local_order && scope.row.local_order.validOrderCount"
                  >
                    成本：{{ formatLocalOrderCost(scope.row) }}
                  </p>
                </div>
                <p v-else>--</p>
              </localOrder>
            </div>

            <!-- 本地事件 -->
            <div v-else-if="item.filedKey === 'local_event'">
              <local-event-cell
                :row="scope.row"
                :level="level"
                :params="params"
                :get-add-pay-api="getAddPayApi"
              ></local-event-cell>
            </div>
            <div v-else-if="item.filedKey === 'budget_type'">
              <budget-type-cell
                :row="scope.row"
                :budget-list-info="budgetListInfo"
              ></budget-type-cell>
            </div>
            <div v-else-if="item.filedKey === 'ad_sale'">
              <div
                v-if="abSaleLoading"
                class="ab-sale-loading"
              >
                <i class="el-icon-loading"></i>
              </div>
              <ab-sale-cell
                v-else
                :row="scope.row"
                :ab-sale-map="abSaleMap"
              />
            </div>
            <!-- 单独接口 点击加载 -->
            <span v-else>{{ formatedCellValueV2(scope.row, item) }}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div
      class="table-pagination"
      v-if="accountId && accountId.length"
    >
      <span
        v-if="pagingHasMore"
        class="pager-tip"
      >仅展示前 10000 条</span>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="params.page"
        :page-sizes="[20, 50, 100]"
        :page-size="params.page_length"
        :total="pagerTotal"
        @size-change="handlePageSizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
    <!-- 保存为我的筛选条件 -->
    <save-filter-dialog
      :visible.sync="saveFilterShow"
      :params="params"
      @save-filter="handleSaveFilter"
    ></save-filter-dialog>
    <!-- 定制列弹窗 -->
    <!-- <cus-column-dialog
      :account-id="accountId"
      :visible="cusColumnVisible"
      :initCheckedColumns="initCheckedColumns"
      @close-dialog="cusColumnVisible = false"
      :name="myColumsName"
      :level="level"
      @post-save-res="handleGetSaveRes"
      @post-cus-columns="handleGetCusColumns"
    ></cus-column-dialog> -->
    <!-- <cusColumn
      :visible.sync="cusColumnVisible"
      :data="initCheckedColumns"
      sysType="GOOGLE_ASSIST"
      @updateSuccess="handleGetSaveRes"
    ></cusColumn> -->

    <!-- 编辑竞价预算 -->
    <!-- 关联商品 -->
    <!-- 关联商品 -->
    <related-goods
      :accountId="accountId"
      :relateSale="relateSale"
      @close="close('relateSale')"
      :rowMsg="{ ...rowMsg }"
      @getList="refreshTableRow"
      platform="google"
    ></related-goods>
    <!-- 修改广告名称 -->
    <!-- 修改广告名称 -->

    <!-- 批量修改网域 -->
    <!-- 编辑主页 -->
    <!-- 查看受众报告 -->
    <!-- <audience-table
      :show.sync="showAudience"
      :adset="currentAudienceAdset"
      :account-ids="accountId"
      :fields="fields"
      @editAdgroup="f_editAudience"
    ></audience-table> -->
    <!-- 创建广告 -->
    <my-dialog :myDialogObj="createVisible">
      <create-gg-ad
        @closeCreate="f_closeCreate"
        v-if="createVisible.title.indexOf('创建') > -1"
        @changeAdTitles="f_changeAdTitles"
        :accountId="accountIdCreate"
        @success="onCreateSuccess"
      ></create-gg-ad>
      <!-- <campain-form
        :currentNodeCampagin="currentNodeCampagin"
        v-if="createVisible.title.indexOf('复制广告系列') > -1"
        :accountId="accountId"
        :level="level"
        :list="list"
        @closeCreate="f_closeCreate"

      ></campain-form> -->
      <!-- <edit-adgroup v-if="createVisible.title.indexOf('编辑受众') > -1" :accountId="accountId"
        :originData="originData" :value="ruleForm" @closeCreate="f_closeCreate" ></edit-adgroup
      > -->
      <!-- <edit-ad
        @closeCreate="f_closeCreate"
        v-if="createVisible.title.indexOf('编辑广告') > -1"
        :accountId="accountId"
        :originData="originData"
        :value="ruleForm"
      ></edit-ad> -->
    </my-dialog>

    <!-- 编辑广告系列 -->
    <editCampaign
      :editCampaignShow.sync="editCampaignShow"
      :currentRow="currentRow"
    />
    <!-- 编辑广告 -->
    <editAd
      :editAdShow.sync="editAdShow"
      :currentRow="currentRow"
    />
    <!-- 编辑广告组 -->
    <editAdgroup
      :editAdSetShow.sync="editAdSetShow"
      :currentRow="currentRow"
      @editSuccess="handleEditAdgroupSuccess"
    />
    <copy-drawer
      v-if="drawerFlag"
      :drawerFlag="drawerFlag"
      :drawerParams="drawerParams"
      @closeDrawer="closeDrawer"
    >
      <copyForm
        :level="level"
        :copyOriginList="copyOriginList"
        @closeDrawer="closeDrawer"
        @submitDrawerSuccess="submitDrawerSuccess"
      ></copyForm>
    </copy-drawer>
    <BudgetSuggestion
      v-if="budgetSuggestionVisible"
      :budgetSuggestionVisible.sync="budgetSuggestionVisible"
      :googleTableRow="googleTableRow"
      @closeBudgetSuggetion="closeBudgetSuggetion"
    />
    <BidSuggestion
      v-if="bidSuggestionVisible"
      :bidSuggestionVisible.sync="bidSuggestionVisible"
      :googleTableRow="googleTableRow"
      @closeBidSuggetion="closeBidSuggetion"
    />
    <!-- 定时开启关闭 -->
    <!-- 定时开启 -->
    <openClock
      ref="setTimeVue"
      :selectedRowScopes="selectedRowScopesWithAdsetId"
      :level="level"
      platform="google"
      @settingComplete="settingComplete"
      :type="setTimeType"
      :gimpUserId="userInfo.data.id"
    />

    <!-- 操作日志 -->
    <!-- 操作日志 -->
    <logDraw
      :show.sync="showLog"
      needSign
      :apiParams="{
        platform: 'google',
        level: level,
        campaignId: operationData.campaign_id,
        adGroupId: operationData.group_id,
        adId: level == 'ad' ? operationData.id : null,
        adAccountId: operationData.ad_accountId,
      }"
    ></logDraw>

    <!-- 受众看板 -->
    <AudienceDashboard
      ref="audienceDashboard"
      :visible.sync="audienceCardShow"
      :currentRow="currentRow"
      :dateRange="dateRange"
      @editAudience="editAudience"
    />
  </div>
</template>

<script>
// 创建广告
import createGgAd from '@/views/google/createGgAd/index.vue';
import MyDialog from '@/views/google/createGgAd/common/myDialog/index.vue';
// 复制广告系列
import campainForm from '@/views/google/adManagement/copy/campainForm.vue';
import { mapState, mapGetters, mapMutations } from 'vuex';
// 编辑广告（单个）
// import editAd from '@/views/google/adManagement/editAd/index.vue';
import AdCellInlineEditBudget from '@/components/google/AdCellInlineEditBudget';
import AdCellInlineEditTargetCp from '@/components/google/AdCellInlineEditTargetCp';
import AdCellSearchBid from '@/components/google/AdCellSearchBid';
import AdCellName from '@/components/google/AdCellName';
import cusColumnDialog from '@/components/google/cusColumnDialog/index';
import { localOrder } from '@adCommonComponent';
import relatedGoods from '@/views/adManagement/components/table/relatedGoods';
import copyDrawer from './copy/copyDrawer.vue';
import CreateButton from './CreateButton.vue';
// Table cell components
import {
  StatusCell,
  RelatedProductCell,
  LocalEventCell,
  AdTypeCell,
  SpendCell,
  BudgetTypeCell,
  AbSaleCell,
} from '@/components/google/table-cells';
// Filter components
import { FilterPanel, SaveFilterDialog } from '@/components/google/table-filters';
// 查看受众
import audienceTable from '@/components/google/audienceTable.vue';
// 复制系列、广告组、广告
import copyForm from './copy/copyForm.vue';
import { adgroupAudienceInfo, adsInfo } from '@/api/google/ceateAdGg.js';
import { alertScore, bindAuto } from '@/api/adManagement';
import { myFilters, getAdsReport, getAdsReportSummary } from '@/api/google/adManagement';
import {
  deleteColumn,
  deleteFilter,
  saveFilter,
  mutateStatus,
  queryAbSaleList,
  editAbStatus,
  getBaseInfo,
} from '@/api/google/adManagement';
import { getAddPayStat, getLocalOrderStat, getLocalOrderRangeStat } from '@/api/multiPlatform';
import { enrichRowsOwnerInfo, clearOptInfoCache, guardOwner } from '@/utils/ownerGuard';
import { confirmGoogleCampaignRisk } from '@/components/google/riskLevelCheck';
import { supportCreateAd } from '@/api/google/create';
import { getAuthUrl } from '@/api/google/cashVoucher.js';
import BudgetSuggestion from './BudgetSuggestion.vue';
import BidSuggestion from './BidSuggestion.vue';

// 编辑
import editAd from '@/views/google/adManagement/editAd/index.vue';
import editAdgroup from '@/views/google/adManagement/editAdgroup/index.vue';
import editCampaign from '@/views/google/adManagement/editCampaign/index.vue';
// 定时开关
import setTime from '@/views/adManagement/components/table/setTime.vue';
import openSchedule from './openSchedule.vue';
import { adCellProductReport, addPay, logDraw, openClock } from '@adCommonComponent';

import cusColumns from '@/views/components/cusColumns.vue';

// 受众看板
import AudienceDashboard from '@/components/google/AudienceDashboard/index.vue';

const _ = require('lodash');
//筛选【封装】，细分，头部操作，自定义列，弹框，放表格里
///日期选择，放index
const statusList = [
  { key: 'ENABLED', campaign_val: 1, adset_val: 1, ad_val: 1 },
  { key: 'PAUSED', campaign_val: 7, adset_val: 9, ad_val: 8 },
  { key: 'REMOVED', campaign_val: 6, adset_val: 8, ad_val: 7 },
  { key: 'PENDING_REVIEW', campaign_val: 3, adset_val: 3, ad_val: 3 },
  { key: 'DISAPPROVED', campaign_val: 2, adset_val: 2, ad_val: 2 },
  { key: 'PREAPPROVED', campaign_val: 8, adset_val: 10, ad_val: 9 },
  { key: 'PENDING_BILLING_INFO', campaign_val: 9, adset_val: 11, ad_val: 10 },
  { key: 'CAMPAIGN_PAUSED', campaign_val: 10, adset_val: 7, ad_val: 11 },
  { key: 'ARCHIVED', campaign_val: 11, adset_val: 12, ad_val: 12 },
  { key: 'ADSET_PAUSED', campaign_val: 12, adset_val: 13, ad_val: 16 },
  { key: 'IN_PROCESS', campaign_val: 13, adset_val: 4, ad_val: 4 },
  { key: 'WITH_ISSUES', campaign_val: 14, adset_val: 14, ad_val: 5 },
  { key: 'NOAD', campaign_val: 4, adset_val: 6, ad_val: 13 },
  { key: 'CLOSED', campaign_val: 5, adset_val: 4, ad_val: 14 },
];

const typeList = [
  {
    label: '需求开发广告',
    key: 'DEMAND_GEN',
  },
  {
    label: '搜索',
    key: 'SEARCH',
  },
  {
    label: '展示',
    key: 'DISPLAY',
  },
  {
    label: '购物',
    key: 'SHOPPING',
  },
  {
    label: '效果最大化',
    key: 'PERFORMANCE_MAX',
  },
];
const adTypeList = [
  {
    label: '视频',
    key: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
  },
  {
    label: '图片',
    key: 'DEMAND_GEN_MULTI_ASSET_AD',
  },
];
const budgetListInfo = {
  UNSPECIFIED: '未指定',
  UNKNOWN: '未知',
  STANDARD: '标准',
  FIXED_CPA: '固定每次获取成本',
  SMART_CAMPAIGN: '智能活动预算类型',
  LOCAL_SERVICES: '本地服务活动预算类型',
};
function getIndex(key, level) {
  return statusList.filter((v) => v.key == key).length
    ? statusList.filter((v) => v.key == key)[0][`${level}_val`]
    : 100;
}

function caseCade(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
}
export default {
  name: 'AdTable',
  props: {
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    // 当前账户信息
    currentNodeCampagin: {
      type: Object,
      default: () => {},
    },
    level: {
      type: String,
      default: 'campaign',
    },
    activeLevel: {
      type: String,
      default: 'campaign',
    },
    accountId: {
      type: [String, Array],
      default: '',
    },
    initData: {
      type: Object,
      default: () => ({}),
    },
    adsCountObj: {
      type: Object,
      default: () => ({}),
    },
    selectIds: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      accountIdCreate: [],
      originData: {},
      ruleForm: {}, //修改受众
      createVisible: {
        title: '选择广告类型',
        dialogVisible: false,
        width: '1100px',
        top: '5vh',
      },
      filterIcon: require('@/assets/icon/filter.png'),
      tableData: [],
      disAbled: false,
      // loading: false,
      params: {
        account_id: this.accountId,
        action_attribution_windows: this.dateRange.actionAttributionWindows || [],
        after: '',
        date_end: this.dateRange.dateRange[1] || '2020-10-01',
        date_start: this.dateRange.dateRange[0] || '2020-02-20',
        fields: [],
        filtering: [],
        object_filtering: [],
        keyword: '',
        level: 'campaign',
        page: 1,
        page_length: 50,
        paged: true,
        sort: [{ field: 'status', direction: 'ASC' }],
      },
      after: '',
      expandAll: false, //是否展开所有下级，当加载细分的时候默认展开
      expandKeys: [],
      breakdowms: {
        time: '',
        delivery: '',
      },
      maps: new Map(),
      lazy: true,
      // 搜索框
      searchInput: false,
      // 自定义列
      currentColumn: {},
      // 筛选条件
      filterList: [], //我的自定义筛选条件
      cusFilterList: [{ field: '', operator: '', value: '' }],
      filterId: 0,
      filterShow: false,
      checkList: [],
      saveFilterShow: false,
      drawers: {
        copy: { visible: false, rowScopes: [] }, // 复制抽屉
        editBudgetPrice: { visible: false, rowScopes: [], level: this.level }, // 修改竞价预算
      },
      selectedRowScopes: [],

      // 取消上一次请求
      source: null,
      downLoadParams: null,
      relateSale: false, //关联商品
      rowMsg: null,

      summary: {},
      summaryMetricsReady: false,
      pagingHasMore: false,
      refreshIdListOnce: false,
      list: [],

      //   编辑
      editAdShow: false,
      editAdSetShow: false,
      editCampaignShow: false,
      currentRow: {},
      copyOriginList: [],
      drawerFlag: false,
      drawerParams: {
        title: '复制广告系列',
      },
      budgetSuggestionVisible: false,
      googleTableRow: {},
      tableLoading: false, //表格加载
      bidSuggestionVisible: false,
      //   定时
      setTimeType: 1, //1定时开启，4定时关闭

      typeList,
      adTypeList,
      budgetListInfo,
      getAddPayApi: getAddPayStat, //获取加购数据接口
      getLocalOrderStatApi: getLocalOrderStat, //本地订单详情接口（hover 单个加载 dailyStats）

      operationData: {},
      showLog: false,
      columnLoaded: false, // 定制列是否已加载
      needsLayout: false, // 是否需要重新布局
      // 上次加载时的筛选条件快照，用于 tab 切换时判断是否需要重新加载
      lastLoadSnapshot: null,
      abSaleMap: {}, // AB品数据映射
      abSaleLoading: false, // AB品加载状态
      audienceCardShow: false, //受众看板
      mutateStatusLoading: false, // 状态修改接口调用中
    };
  },
  components: {
    AdCellName,
    AdCellInlineEditBudget,
    cusColumnDialog,
    localOrder,
    audienceTable,
    createGgAd,
    MyDialog,
    campainForm,
    editAdgroup,
    editAd,
    AdCellInlineEditTargetCp,
    relatedGoods,
    copyForm,
    copyDrawer,
    BudgetSuggestion,
    BidSuggestion,
    setTime,
    openSchedule,
    adCellProductReport,
    addPay,
    logDraw,
    openClock,
    // Table cell components
    StatusCell,
    RelatedProductCell,
    LocalEventCell,
    AdTypeCell,
    SpendCell,
    BudgetTypeCell,
    AbSaleCell,
    // Filter components
    FilterPanel,
    SaveFilterDialog,
    cusColumns,
    editCampaign,
    CreateButton,
    AdCellSearchBid,

    AudienceDashboard,
  },
  filters: {
    showName(item) {
      return item ? (item['name'] ? item['name'] : '') : '请选择';
    },
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapState('num', ['selectedNum']),
    ...mapGetters('num', ['toFormatedMoneyV2', 'currentUiUnit']),
    ...mapGetters('googleAdActiveTab', [
      'selectCampaignsOld',
      'selectCampaignsNew',
      'selectAdsetsOld',
      'selectAdsetsNew',
      'selectAdsOld',
      'selectAdsNew',
      'campaignDateRangOld',
      'campaignDateRangNew',
      'adsetDateRangNew',
      'adsetDateRangOld',
      'adDateRangNew',
      'adDateRangOld',
    ]),
    editCopyList() {
      return this.list.filter((v) => v.level == this.level);
    },
    filteringList() {
      return (item) => {
        if (!this.initData || !this.initData.FilterFields || !item) return [];
        const filterObj = this.initData.FilterFields.find((v) => v.filedKey == item.field);
        return filterObj && filterObj.filtering ? filterObj.filtering : [];
      };
    },
    typesList() {
      if (this.level == 'ad') {
        return this.adTypeList;
      } else {
        return this.typeList;
      }
    },
    // 给selectedRowScopes每一项添加adset_id，取值为group_id
    selectedRowScopesWithAdsetId() {
      return this.selectedRowScopes.map((v) => ({
        ...v,
        adset_id: v.group_id,
      }));
    },
    pagerTotal() {
      if (this.pagingHasMore) {
        return 10000;
      }
      return Number(this.summary.total_count) || 0;
    },
    // campaignCount() {
    //   return this.selectedRowScopes.filter((v) => v.level === 'campaign').length;
    // },
    // adsetCount() {
    //   return this.selectedRowScopes.filter((v) => v.level === 'adset').length;
    // },
    // adCount() {
    //   return this.selectedRowScopes.filter((v) => v.level === 'ad').length;
    // },
    currentShowColumnList() {
      let excludeList = this.defaultFields.slice(0, 5);
      let list = this.currentColumn?.columns?.[this.level] || [];
      let filtered = list.filter((v) => excludeList.indexOf(v.filedKey) == -1);
      // asset 层级的 asset_resource 已作为固定列渲染，从动态列中排除
      if (this.level === 'asset') {
        filtered = filtered.filter((v) => v.filedKey !== 'asset_resource');
      }
      return filtered;
    },
    currentColumnList() {
      let list = this.currentColumn?.columns?.[this.level] || [];
      return list;
    },
    defaultFields() {
      return ['campaign_name', 'group_name', 'ad_name', 'campaign_ref', 'status', 'type'];
    },
  },
  watch: {
    accountId: async function (v, ov) {
      clearOptInfoCache();
      this.filterShow = false;
      this.params.filtering = [];
      // 非当前 tab 不会发起请求，先清掉上个账户的数据，避免切回来时看到旧账户的行
      if (this.level !== this.activeLevel) {
        this.tableData = [];
        this.summary = {};
        this.summaryMetricsReady = false;
        this.pagingHasMore = false;
      }
      this.resetPageAndReload();
    },
    dateRange: {
      handler(val) {
        this.setDateRangeParam();
      },
      deep: true,
    },
  },
  created() {
    let filteringStr = localStorage.getItem(`filter_${this.accountId}`);
    if (filteringStr && JSON.parse(filteringStr).length) {
      this.params.filtering = JSON.parse(filteringStr);
      this.filterShow = true;
    }
    this.debouncedReloadTable = _.debounce(this.reloadTable, 500);
    this.throttledQueryAbSale = _.throttle(this.queryAbSaleData, 1000);
  },
  mounted() {
    this.getMyFilter();
    // this.debouncedReloadTable();
    // this.$bus.$on('createAd', (data) => {
    //   console.log(data, 'data--------------------');
    //   this.accountIdCreate = [data.id];
    //   this.$store.commit('google/setCreateAdAccount', data);

    //   this.handleCommandClick();
    // });
  },
  beforeDestroy() {
    this.$bus.$off('createAd');
  },
  updated() {
    // 只在必要时重新布局
    if (this.needsLayout) {
      this.$refs['table']?.doLayout();
      this.needsLayout = false;
    }
  },
  methods: {
    ...mapMutations(['audiences/setMultipleAdsets']),
    ...mapState(['google/createAdAccount']),
    // 获取行唯一标识，asset 层级用 asset_id 拼接广告 id 避免重复 key
    getRowKey(row) {
      if (this.level === 'asset') {
        return `${row.asset_id}_${row.ad_id}`;
      }
      return row.id;
    },
    // 创建标准广告
    async f_create(type) {
      this.accountIdCreate = this.accountId;
      // this.$store.commit('google/setCreateAdAccount', this.currentNodeCampagin);
      this.handleCommandClick(type);
    },
    // 根据广告类型改变弹窗标题
    f_changeAdTitles(t) {
      this.createVisible.title = `创建${t}广告`;
    },
    // 关闭弹窗
    f_closeCreate() {
      this.createVisible.dialogVisible = false;
    },
    alertScore({ id, score }) {
      let params = {
        id,
        score,
      };
      alertScore(params).then((res) => {
        if (res.code == 0) {
        }
      });
    },
    reviewScore({ curTableRow, curRow, curIndex, flag }) {
      if (curTableRow.level == this.level) {
        this.$refs.table.store.states.data.map((k, i) => {
          if (k.id == curTableRow.id) {
            this.$refs.table.store.states.data[i].status_hints[curIndex].alertScore = flag;
          }
        });
      } else {
        // 不是当前级别
        let parentId = curTableRow.level == 'adset' ? curTableRow.campaign_id : curTableRow.adset_id;
        let list = this.$refs.table.store.states.lazyTreeNodeMap[parentId];
        list.map((v, index) => {
          if (v.id == curTableRow.id) {
            this.$refs.table.store.states.lazyTreeNodeMap[parentId][index].status_hints[curIndex].alertScore = flag;
          }
        });
      }
      this.alertScore({ id: curRow.alertId, score: flag });
    },

    setManageAssess() {
      let sel = [],
        idKey = '';
      if (this.level == 'adset') {
        sel = this.selectIds.selectCampaigns;
        idKey = 'campaign_id';
      }
      let arr = [...this.tableData];
      arr.forEach((item, index) => {
        let obj = sel.find((s) => s.id == item[idKey]);
        if (obj) {
          item.product_report = obj.product_report;
          item.adProductReport = obj.adProductReport;
          item.campaignPurchase = obj.object_actions || obj.purchase || obj.purchase_web;
          item.campaignCost = obj.spend;
        }
      });
      this.tableData = [...arr];
    },

    // 关联商品
    relateSaleClick({ row }) {
      this.rowMsg = { row };
      this.$set(this.rowMsg, 'row', { ...row, name: row.campaign_name });
      this.relateSale = true;
    },
    cancelQuest() {
      if (typeof this.source === 'function') {
        this.source();
      }
    },
    specialFields(params) {
      if (params.level === 'ad') return ['creative'];

      const hasProductReport = params.fields.includes('product_report');
      if (!hasProductReport) return [];

      const fields = ['adProductReport'];
      if (!params.fields.includes('local_order')) fields.push('local_order');
      if (!params.fields.includes('spend')) fields.push('spend');

      return fields;
    },
    close(v) {
      this[v] = false;
    },
    setDateRangeParam() {
      const { actionAttributionWindows, dateRange } = this.dateRange;
      this.params.action_attribution_windows = actionAttributionWindows;
      [this.params.date_start, this.params.date_end] = dateRange;
      const level = caseCade(this.level);
      this.$store.commit(`googleAdActiveTab/set${level}DateRangNew`, this.dateRange);
      this.resetPageAndReload();
      this.$store.commit(`googleAdActiveTab/set${level}DateRangOld`, this.dateRange);
    },

    formatedCellValueV2(row, columnDefine) {
      let { filedKey, columnType } = columnDefine,
        v = row[filedKey],
        empty = v === null || v === undefined || v === '';
      let val = row[filedKey];
      if (!empty) {
        switch (columnType) {
          case 'currency':
            val = `${row.currency || '$'} ${v}`;
            break;
          case 'percent':
            val = parseFloat(v).toFixed(2) + '%';
            break;
          case 'INT':
            val = parseInt(v);
            break;
          case 'DECIMAL':
            val = parseFloat(v).toFixed(2);
            break;
          default:
            val = v;
            break;
        }
      }
      return `${val || val === 0 ? val : '--'}`;
    },
    tabChangeReloadTable(level) {
      // 生成当前筛选条件快照
      const currentSnapshot = this.buildLoadSnapshot(level);
      const lastSnapshot = this.lastLoadSnapshot;

      // 首次加载（无快照）或快照有变化时重新加载
      if (!lastSnapshot || JSON.stringify(currentSnapshot) !== JSON.stringify(lastSnapshot)) {
        this.lastLoadSnapshot = currentSnapshot;
        this.resetPageAndReload();
        if (level !== 'ad') {
          this.setSel();
        }
      }
    },
    // 根据层级构建当前筛选条件快照
    buildLoadSnapshot(level) {
      const snapshot = { level, accountId: JSON.stringify(this.accountId) };

      if (level === 'campaign') {
        // 广告系列只关心日期
        snapshot.dateRange = JSON.stringify(this.dateRange);
      } else if (level === 'adset') {
        // 广告组关心：选中的广告系列 + 日期
        snapshot.campaigns = JSON.stringify(this.selectCampaignsNew);
        snapshot.dateRange = JSON.stringify(this.dateRange);
      } else if (level === 'ad') {
        // 广告关心：选中的广告系列 + 广告组 + 日期
        snapshot.campaigns = JSON.stringify(this.selectCampaignsNew);
        snapshot.adsets = JSON.stringify(this.selectAdsetsNew);
        snapshot.dateRange = JSON.stringify(this.dateRange);
      } else if (level === 'asset') {
        // 素材资源关心：选中的广告系列 + 广告组 + 广告 + 日期
        snapshot.campaigns = JSON.stringify(this.selectCampaignsNew);
        snapshot.adsets = JSON.stringify(this.selectAdsetsNew);
        snapshot.ads = JSON.stringify(this.selectAdsNew);
        snapshot.dateRange = JSON.stringify(this.dateRange);
      }

      return snapshot;
    },
    // 选中状态回显
    setSel() {
      let sel = [];
      if (this.level == 'adset') {
        sel = this.selectIds.selectAdsets;
      }
      sel.forEach((item) => {
        let obj = this.tableData.find((row) => row.id == item.id);
        if (obj) {
          this.$refs.table.toggleRowSelection(obj, true);
        }
      });
    },
    // 编辑广告组
    editAudience(currentRow) {
      this.editAdSetShow = true;
      this.currentRow = currentRow;
    },
    // 点击编辑
    async handleEditCommand(v) {
      console.log(v);
      const ownerRows = v.scope ? [v.scope.row] : this.selectedRowScopes;
      if (!(await guardOwner(ownerRows))) return;
      switch (v.type) {
        // 编辑广告系列竞价预算
        case 'campaign':
        case 'adset':
          this.drawers.editBudgetPrice.visible = true;
          const rowScopes = v.scope ? [v.scope.row] : this.selectedRowScopes;
          const level = v.scope ? v.scope.row.level : this.level;
          this.drawers.editBudgetPrice.rowScopes = rowScopes;
          this.drawers.editBudgetPrice.level = level;
          break;
        // 编辑广告系列
        case 'editCampaign':
          this.editCampaignShow = true;
          this.editAdSetId = v.scope.row.id;
          this.adsetScope = v.scope;
          this.currentRow = v.scope.row;
          break;

        // 编辑广告组
        case 'editAdset':
          this.editAdSetShow = true;
          this.currentRow = v.scope.row;
          break;
        // 编辑广告
        case 'editAd':
          this.editAdShow = true;
          this.currentRow = v.scope.row;
          break;
        case 'audienceCard':
          this.audienceCardShow = true;
          this.currentRow = v.scope.row;
          break;
        default:
          break;
      }
    },

    // 切换筛选条件
    handleFilterCommand(v) {
      this.filterShow = true;
      let filtering = JSON.parse(JSON.stringify(v.filtering));
      this.params.filtering = filtering.map((v) => {
        if (v.field == 'objective' || v.field == 'status') {
          v.value1 = v.value;
        }
        return v;
      });
      this.resetPageAndReload();
    },
    handleSaveFilterSearch() {
      this.filterShow = true;
      console.log(this.cusFilterList, 'this.cusFilterList');
      this.params.filtering = JSON.parse(JSON.stringify(this.cusFilterList)).slice(0, this.cusFilterList.length - 1);
      if (this.params.filtering.filter((v) => v.field == 'status').length) {
        this.checkList = this.params.filtering.filter((v) => v.field == 'status')[0].value1;
      }
      this.saveFilterStorage();
      this.resetPageAndReload();
    },
    handleDeleteFilterTag({ tag, index }) {
      this.deleFilterTag(tag, index);
    },
    handleSaveFilter(data) {
      this.$showLoading();
      data.filtering.map((v) => {
        v.value = v.value1 && v.value1.length ? v.value1 : v.value;
      });
      saveFilter(data).then((res) => {
        this.$hideLoading();
        if (res.code == 0) {
          this.saveFilterShow = false;
          this.getMyFilter();
        }
      });
    },
    deleFilterObj(index) {
      this.cusFilterList.splice(index, 1);
    },
    addFilterItem() {
      this.cusFilterList.push({
        field: '',
        operator: '',
        value: '',
        value1: [],
      });
    },
    handleFieldChange({ list, obj, index }) {
      this.$set(list, index, obj);
    },
    // 监听筛选条件value的变换
    valueChange(v) {
      this.saveFilterStorage();
      this.resetPageAndReload();
    },
    // 筛选条件符号的变化
    operatorChange() {
      this.saveFilterStorage();
    },
    // 筛选条件存入缓存
    saveFilterStorage() {
      localStorage.setItem(`filter_${this.accountId}`, JSON.stringify(this.params.filtering));
    },
    objectFilteringBySection() {
      let filteringCampaignIds = [];
      let filteringAdseIds = [];
      if (this.selectIds && this.selectIds.selectCampaigns && this.selectIds.selectCampaigns.length > 0) {
        let obj = {
          field: 'campaign.id',
          operator: 'IN',
          value: this.selectIds.selectCampaigns.map((v) => v.id),
        };
        filteringCampaignIds.push(obj);
      }
      if (this.selectIds && this.selectIds.selectAdsets && this.selectIds.selectAdsets.length > 0) {
        let obj = {
          field: 'adset.id',
          operator: 'IN',
          value: this.selectIds.selectAdsets.map((v) => v.id),
        };
        filteringAdseIds.push(obj);
      }
      switch (this.level) {
        case 'adset':
          return filteringCampaignIds;
        case 'ad':
          return filteringCampaignIds.concat(filteringAdseIds);
        case 'asset':
          let filteringAdIds = [];
          if (this.selectIds && this.selectIds.selectAds && this.selectIds.selectAds.length > 0) {
            this.selectIds.selectAds.forEach((v) => {
              filteringAdIds.push({
                field: 'ad_id',
                operator: 'EQUAL',
                value: v.id + '',
              });
            });
          }
          return filteringCampaignIds.concat(filteringAdseIds).concat(filteringAdIds);
      }
      return [];
    },

    async reloadTable(opts) {
      if (!this.accountId || !this.accountId.length || !this.columnLoaded) return;
      //初始化，或刷新
      document.getElementsByClassName('el-table__body-wrapper')[0].scrollTop = 0;
      this.after = '';
      let params = JSON.parse(JSON.stringify(this.params));
      let filedList = this.currentColumnList.map((v) => v.filedKey);
      params.fields = this.defaultFields.concat(filedList);
      params.after = '';
      // 处理筛选条件
      let filtering = JSON.parse(JSON.stringify(params.filtering));
      filtering.map((item) => {
        if (item.field == 'status' || item.field == 'objective') {
          item.value = item.value1 ? JSON.parse(JSON.stringify(item.value1)) : item.value;
        }
        delete item.value1;
      });
      // 从filtering 里面取出object_filtering 的项
      let object_filtering = filtering.filter(
        (v) => v.field == 'status' || v.field == 'approval_status' || (v.field == 'objective' && v.value.length),
      );
      params.object_filtering = object_filtering.concat(this.objectFilteringBySection());
      params.filtering = filtering.filter(
        (v) => v.field != 'status' && v.field != 'objective' && v.field != 'approval_status',
      );
      params.level = this.level;
      if (this.level !== this.activeLevel) {
        return false;
      }
      params.isLoadChildren = false;
      params.paged = true;
      const forceRefresh =
        (opts && typeof opts === 'object' && opts.refreshIdList === true) || this.refreshIdListOnce;
      params.refreshIdList = !!forceRefresh;
      this.refreshIdListOnce = false;
      this.tableLoading = true;
      return this.getList(params).then(async (res) => {
        this.tableLoading = false;
        this.tableData = res;
        // 清除掉子项缓存
        Object.keys(this.$refs.table.store.states.lazyTreeNodeMap).map((v) => {
          delete this.$refs.table.store.states.lazyTreeNodeMap[v];
        });
        this.tableData.map((v) => {
          if (this.$refs.table.store.states.treeData[v]) {
            this.$refs.table.store.states.treeData[v].loaded = false;
            this.$refs.table.store.states.treeData[v].expanded = false;
            this.$refs.table.store.states.treeData[v].children = [];
            this.$set(this.$refs.table.store.states.treeData, v, this.$refs.table.store.states.treeData[v]);
          }
        });
        this.clearChidren(this.tableData.map((v) => v.id));
        // 广告系列-单独调用接口拿到经营分析数据
        if (this.level == 'campaign') {
          // 调用AB品接口
          this.throttledQueryAbSale();
        } else {
          this.setManageAssess();
        }

        this.$forceUpdate();
        // 加载成功后更新快照，记录本次加载时的筛选条件
        this.lastLoadSnapshot = this.buildLoadSnapshot(this.level);
        return;
      });
    },
    reloadWithIdRefresh() {
      this.refreshIdListOnce = true;
      this.debouncedReloadTable();
    },
    // 和几行数据
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // asset 层级没有复选框列，合计文字应显示在第一列（素材资源列）
      const summaryIndex = this.level === 'asset' ? 0 : 1;
      columns.forEach((item, index) => {
        if (index < summaryIndex) {
          sums[index] = '';
          return;
        } else if (index == summaryIndex) {
          let n = this.summary?.total_count || 0;
          if (this.pagingHasMore) {
            n = '10000+';
          }
          sums[index] = `${n}条${
            this.level == 'campaign'
              ? '广告系列'
              : this.level == 'adset'
              ? '广告组'
              : this.level == 'ad'
              ? '广告'
              : '素材资源'
          }的成效`;
        } else {
          let row = this.currentColumnList.filter((v) => v.filedKey == item.property)[0];
          if (row && this.summaryMetricsReady) {
            sums[index] = this.summary ? this.formatedCellValueV2(this.summary, row) : '--';
          } else {
            sums[index] = '--';
          }
        }
      });
      return sums;
    },
    // 删除当前筛选条件
    deleFilterTag(tag, i) {
      this.params.filtering.splice(i, 1);
      if (!this.params.filtering.length) {
        this.filterShow = false;
      }
      if (tag.field == 'status') {
        this.checkList = [];
      }
      tag.value1 = tag.value1 || [];
      if (tag.field && tag.operator && (tag.value !== '' || tag.value1.length)) {
        this.saveFilterStorage();
        this.resetPageAndReload();
      }
    },
    // 监听筛选条件field的变化
    fieldChange(list, v, i) {
      const obj = JSON.parse(JSON.stringify(v));
      const filtering = this.initData.FilterFields.find((item) => item.filedKey == v.field);

      obj.operator = filtering && filtering.filtering.length == 1 ? filtering.filtering[0].key : '';
      obj.value = '';
      obj.value1 = [];

      this.$set(list, i, obj);
    },

    // 添加当前筛选条件
    addTag() {
      this.params.filtering.push({ field: '', operator: '', value: '', value1: [] });
    },

    // 关闭当前的筛选条件
    closeMyFilter() {
      this.filterShow = false;
      this.cusFilterList = [{ field: '', operator: '', value: '', value1: [] }];
      this.params.filtering = [];
      this.checkList = [];
      this.saveFilterStorage();
      this.resetPageAndReload();
    },

    // 删除我的查询条件
    async deleFilterGroup(v) {
      const formData = new FormData();
      formData.append('id', v);
      this.$showLoading();

      try {
        const res = await deleteFilter(formData);
        if (res.code == 0) {
          this.$message({ type: 'success', message: '删除成功' });
          this.getMyFilter();
        }
      } finally {
        this.$hideLoading();
      }
    },
    // 获取我的查询条件
    getMyFilter() {
      myFilters().then((res) => {
        this.filterList = res.data;
      });
    },
    // 定制列
    getCurrentColumn(currentColumn) {
      const newColumn = JSON.parse(JSON.stringify(currentColumn));
      const hasChanged = JSON.stringify(this.currentColumn) !== JSON.stringify(newColumn);
      console.log(hasChanged, 'hasChangedhasChangedhasChanged');
      this.currentColumn = newColumn;
      this.columnLoaded = true;

      if (hasChanged) {
        this.needsLayout = true;
        this.params.page = 1;
        this.reloadTable();
      }
    },
    // 关键词变化
    keywordChange() {
      this.resetPageAndReload();
    },
    // 自定义排序
    compare(propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName] || 0;
        var value2 = obj2[propertyName] || 0;
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh');
          return sort === 'ascending' ? res : -res;
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1;
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1;
          }
        }
      };
    },
    manualSort(item) {
      let key = item.filedKey || item.prop;
      return [
        'add_payment_info',
        'add_payment_info_cost',
        'add_to_cart',
        'add_to_cart_cost',
        'add_to_cart_web',
        'add_to_cart_web_cost',
        'content_view_web',
        'content_view_web_cost',
        'credit_spent',
        'fb_pixel_add_payment_info',
        'fb_pixel_initiate_checkout',
        'initiated_checkout_web_cost',
        'initiate_checkout',
        'initiate_checkout_cost',
        'landing_page_view',
        'like',
        'link_click',
        'photo_view',
        'post',
        'purchase',
        'purchase_cost',
        'purchase_web',
        'purchase_web_cost',
        'purchase_web_value',
        'video_view',
        'view_content',
        'view_content_cost',
        'local_order',
        'effective_status',
      ].includes(key);
    },
    // 监听表格排序
    sortChange(v) {
      if (v.prop === 'local_order') {
        this.tableData.sort(this.compare('localsOrderNum', v.order));
        this.$refs.table.doLayout();
        return;
      }
      let nextSort = [{ field: 'status', direction: 'ASC' }];
      if (v.prop && v.order) {
        let field = v.prop;
        if (v.prop === 'effective_status' || v.prop === 'status') {
          field = 'status';
        } else if (v.prop === 'name') {
          field = this.level === 'adset' ? 'group_name' : this.level === 'ad' ? 'ad_name' : 'campaign_name';
        }
        nextSort = [
          {
            field,
            direction: v.order === 'ascending' ? 'ASC' : 'DESC',
          },
        ];
      }
      if (JSON.stringify(nextSort) === JSON.stringify(this.params.sort)) {
        return;
      }
      this.params.sort = nextSort;
      this.resetPageAndReload();
    },

    // 表格表头筛选
    selectStatus(v) {
      const i = this.params.filtering.findIndex((m) => m.field == 'status');
      if (i >= 0) {
        const item = this.params.filtering[i];
        item.value1 = v;
        item.value = '';
        this.$set(this.params.filtering, i, item);
      } else {
        let obj = { field: 'status', operator: 'IN', value1: v, value: '' };
        this.params.filtering.push(obj);
      }
      this.resetPageAndReload();
    },
    async copyRow(scope) {
      // 当前的账户、当前的mcc、当前的列表需要传过去
      if (!(await guardOwner([scope.row]))) return;
      if (!(await confirmGoogleCampaignRisk(this, [scope.row]))) return;
      this.copyOriginList = [scope.row];
      this.drawerParams = {
        title: this.level === 'campaign' ? '复制广告系列' : this.level === 'adset' ? '复制广告组' : '复制广告',
      };
      this.drawerFlag = true;
    },
    closeDrawer() {
      this.drawerFlag = false;
    },
    submitDrawerSuccess() {
      this.drawerFlag = false;
      this.reloadTable();
    },
    rollbackStatusSwitch(scope, oldValue) {
      if (scope && scope.row && oldValue) {
        scope.row.status = oldValue;
      }
    },
    async confirmCampaignEnableRisk(scope, status, oldValue) {
      const turningOn = scope ? !status && scope.row.status === 'ENABLED' : status === 'ENABLED';
      const campaignLevel = scope ? scope.row.level === 'campaign' : this.level === 'campaign';
      if (!turningOn || !campaignLevel) return true;
      const rows = scope ? [scope.row] : this.selectedRowScopes;
      const passed = await confirmGoogleCampaignRisk(this, rows);
      if (!passed) this.rollbackStatusSwitch(scope, oldValue);
      return passed;
    },
    // 修改状态
    async setStatus(scope, status, oldValue) {
      const ownerRows = scope ? [scope.row] : this.selectedRowScopes;
      if (!(await guardOwner(ownerRows))) {
        this.rollbackStatusSwitch(scope, oldValue);
        return;
      }
      if (!(await this.confirmCampaignEnableRisk(scope, status, oldValue))) return;
      // 单个删除 传scope status 批量删除 传status  批量开启暂停传 status  单个开启暂停传scope
      if (status === 'REMOVED') {
        this.$confirm('确定要删除吗？删除后将无法恢复。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.mutateStatus(scope, status, oldValue);
          })
          .catch(() => {});
        return;
      }
      this.mutateStatus(scope, status, oldValue);
    },
    mutateStatus(scope, status, oldValue) {
      const newStatus = status || scope?.row?.status;
      let resourceNames = [];
      let statusUpdates = [];
      if (scope) {
        resourceNames = [scope.row.resource_name];
        statusUpdates = [
          {
            resourceName: scope.row.resource_name,
            status: newStatus,
            oldVal: oldValue || '',
          },
        ];
      } else {
        resourceNames = this.selectedRowScopes.map((item) => item.resource_name);
        statusUpdates = this.selectedRowScopes.map((item) => ({
          resourceName: item.resource_name,
          status: newStatus,
          oldVal: item.status, // 批量操作时无旧值
        }));
      }
      let params = {
        customerId: this.accountId.toString(),
        resourceNames,
        statusUpdates,
        status: newStatus,
        level: scope?.row?.level || this.level,
      };
      // 接口调用前显示"正在修改"提示（右下角）
      this.mutateStatusLoading = true;
      const loadingNotify = this.$notify({
        title: '正在处理',
        message: '状态修改中，请稍候...',
        type: 'info',
        position: 'bottom-right',
        duration: 0,
        iconClass: 'el-icon-loading',
        customClass: 'rounded-lg shadow-lg',
      });
      mutateStatus(params)
        .then((res) => {
          loadingNotify.close();
          this.mutateStatusLoading = false;
          if (res.code == 0) {
            this.$message({ type: 'success', message: '成功' });
            this.refreshBaseInfo(scope);
          } else {
            this.$message({ type: 'error', message: res.message || '状态修改失败' });
            // 失败时恢复到旧状态
            if (scope && oldValue) {
              scope.row.status = oldValue;
            } else if (scope) {
              scope.row.status =
                scope.row.status == 'ENABLED' ? 'PAUSED' : scope.row.status == 'PAUSED' ? 'ENABLED' : scope.row.status;
            }
          }
        })
        .catch(() => {
          loadingNotify.close();
          this.mutateStatusLoading = false;
          this.$message({ type: 'error', message: '网络异常，请稍后重试' });
          // 网络异常时也恢复到旧状态
          if (scope && oldValue) {
            scope.row.status = oldValue;
          }
        });
    },
    // 抽取的 getBaseInfo 调用方法
    refreshBaseInfo(scope) {
      const adIds = scope ? [scope.row.id.toString()] : this.selectedRowScopes.map((item) => item.id.toString());
      const baseInfoParams = {
        userId: this.userInfo?.data?.id || 0,
        accountId: Number(this.accountId) || 0,
        level: scope?.row?.level || this.level,
        adIds: adIds,
      };
      getBaseInfo(baseInfoParams)
        .then((baseRes) => {
          if (baseRes.code === 0 && baseRes.data) {
            Object.keys(baseRes.data).forEach((id) => {
              const newData = baseRes.data[id];
              if (scope && scope.row.id.toString() === id) {
                this.updateRowData(scope.row, newData);
              } else {
                const targetRow = this.selectedRowScopes.find((item) => item.id.toString() === id);
                if (targetRow) {
                  this.updateRowData(targetRow, newData);
                }
                const tableRow = this.tableData.find((item) => item.id.toString() === id);
                if (tableRow) {
                  this.updateRowData(tableRow, newData);
                }
              }
            });
          }
        })
        .catch((err) => {
          console.error('getBaseInfo error:', err);
        });
    },
    // 更新行数据的辅助方法
    updateRowData(row, newData) {
      if (newData.primary_status !== undefined) {
        this.$set(row, 'primary_status', newData.primary_status);
      }
      if (newData.primary_status_reasons !== undefined) {
        this.$set(row, 'primary_status_reasons', newData.primary_status_reasons);
      }
      if (newData.status !== undefined) {
        this.$set(row, 'status', newData.status);
      }
      if (newData.effective_status !== undefined) {
        this.$set(row, 'effective_status', newData.effective_status);
      }
      if (newData.name !== undefined) {
        this.$set(row, 'name', newData.name);
      }
      if (newData.approvalStatus !== undefined) {
        this.$set(row, 'approvalStatus', newData.approvalStatus);
      }
    },
    // 清除行的子项
    clearChidren(list) {
      list.forEach((k) => {
        Object.keys(this.$refs.table.store.states.lazyTreeNodeMap).forEach((v) => {
          if (v == k) {
            delete this.$refs.table.store.states.lazyTreeNodeMap[v];
          }
        });
        const treeData = this.$refs.table.store.states.treeData[k];
        if (treeData) {
          treeData.loaded = false;
          treeData.expanded = false;
          treeData.children = [];
          this.$set(this.$refs.table.store.states.treeData, k, treeData);
        }
      });
      this.tableData.forEach((item, index) => {
        if (list.includes(item.id)) {
          item.hasChildren = true;
          this.$refs.table.toggleRowExpansion(item, false);
          this.$set(this.tableData, index, item);
        }
      });
    },

    refreshTableRow(scope) {
      // 移除强制更新，让Vue自然响应数据变化
    },

    // expandChange 切换表格的展开项
    expandChange(row, expanded) {
      if (!this.$refs.table.store.states.lazyTreeNodeMap[row.id] && expanded && row.level != 'ad') {
        if (this.maps.get(row.id)) {
          const { tree, treeNode, resolve } = this.maps.get(row.id);
        }
      }
    },

    // 加载广告系列子集
    loadChildren(tree, treeNode, resolve) {
      let level = '';
      let product_report = tree.product_report;
      let adProductReport = tree.adProductReport;
      let purchase = tree.object_actions || tree.purchase || tree.purchase_web;
      let cost = tree.spend;
      this.maps.set(tree.id, { tree, treeNode, resolve });
      if (this.$refs.table.store.states.lazyTreeNodeMap[tree.id]) {
        resolve(this.$refs.table.store.states.lazyTreeNodeMap[tree.id]);
        return false;
      }
      let obj;
      if (tree.level == 'campaign') {
        level = 'adset';
        obj = { field: 'campaign.id', operator: 'IN', value: [tree.id] };
        this.params.object_filtering.push(obj);
      } else if (tree.level == 'adset') {
        level = 'ad';
        obj = { field: 'adset.id', operator: 'IN', value: [tree.id] };
        this.params.object_filtering.push(obj);
      } else {
        setTimeout(() => {
          resolve([]);
        }, 100);
        return false;
      }
      let params = JSON.parse(JSON.stringify(this.params));
      let filedList = this.currentColumnList.map((v) => v.filedKey);
      params.fields = this.defaultFields.concat(filedList);
      params.object_filtering = [obj];
      let filtering = JSON.parse(JSON.stringify(this.params.filtering));
      params.filtering = filtering.filter((v) => v.field != 'status' && v.field != 'objective' && v.value !== '');
      params.level = level;
      params.after = '';
      params.paged = false;
      params.isLoadChildren = true;
      this.getList(params).then((res) => {
        // 给每一行加上经营分析
        // 不加载广告经营分析
        if (tree.level == 'campaign') {
          res.forEach((v) => {
            v.product_report = product_report;
            v.adProductReport = adProductReport;
            v.campaignPurchase = purchase;
            v.campaignCost = cost;
          });
        }
        setTimeout(() => {
          resolve(res);
        }, 200);
      });
    },
    // 获取点击name传过来的id
    openNextLevel(row, level) {
      this.$refs.table.clearSelection();
      this.$refs.table.toggleRowSelection(row, true);
      this.$emit('selection-change', this.level, [row]);
      this.$emit('select-tab', { name: level, row });
    },
    // 监听选择表格的选择项
    handleSelectionChange(v) {
      this.selectedRowScopes = v;

      if (this.level == 'campaign') {
        this.$store.commit('googleAdActiveTab/setSelectCampaignNew', v);
      } else if (this.level == 'adset') {
        this.$store.commit('googleAdActiveTab/setSelectAdsetsNew', v);
      } else if (this.level == 'ad') {
        this.$store.commit('googleAdActiveTab/setSelectAdsNew', v);
      }
      this.$emit('selection-change', this.level, v);
    },
    // 清除表格选择项
    clearIds() {
      this.selectedRowScopes = [];
      this.$refs.table.clearSelection();
      // 只发送事件，不触发重新加载
      this.$emit('selection-change', this.level, []);
    },
    resetPageAndReload() {
      this.params.page = 1;
      this.debouncedReloadTable();
    },
    handlePageChange(page) {
      this.params.page = page;
      this.reloadTable();
    },
    handlePageSizeChange(size) {
      this.params.page_length = size;
      this.params.page = 1;
      this.reloadTable();
    },
    // 获取列表
    async getList(data) {
      let params = data;
      params.fields = params.fields.concat(this.specialFields(params));
      this.cancelQuest();
      console.log(params, '组合前');
      params.account_ids = this.accountId;
      params.fields = [...new Set([...params.fields, 'resource_name', 'type', 'campaign_id'])];
      delete params.account_id;
      console.log(params, '组合后');
      return getAdsReport(params)
        .then((res) => {
          const hasMore = !!(res.data && res.data.paging && res.data.paging.hasMore);
          this.pagingHasMore = hasMore;
          const totalCount = res.data.summary ? res.data.summary.total_count : 0;
          this.$emit('getNum', params.level + 's', totalCount, hasMore);
          if (res.code != 0) {
            return [];
          }
          if (params.level == this.level && res.data.paging && res.data.paging.after) {
            this.after = res.data.paging.after;
          }
          if ((this.level == 'ad' || this.level == 'asset') && this.$refs.table) {
            this.$set(this.$refs.table.store.states, 'lazy', false);
          } else {
            this.$set(this.$refs.table.store.states, 'lazy', true);
          }
          res.data.data.forEach((v, index) => {
            // 给每一列加上本地订单数量,状态索引，方便本地排序
            // v.localsOrderNum = v.local_order?.orderCount || 0;
            v.statusIndex = v.effective_status ? getIndex(v.effective_status, v.level) : 100;
            v.rowAccountId = v.ad_accountId;
            if (v.level != 'ad' && v.level != 'asset') {
              v.hasChildren = true;
            } else {
              v.hasChildren = false;
            }
            if (
              v.level == 'campaign' &&
              v.campaign_ref == 'NOT_REF' &&
              this.currentColumnList.some((item) => item.filedKey === 'campaign_ref')
            ) {
              this.setRelateGoods(v);
              v.campaign_ref = 'REFING';
            }
            // 初始化本地订单加载状态
            this.$set(v, '_localOrderLoading', true);
          });

          // 异步加载本地订单数据
          if (!data.isLoadChildren) {
            this.loadLocalOrderData(res.data.data, params);
          }

          // this.$refs.table.doLayout();
          this.summary = res.data.summary || {};
          this.summaryMetricsReady = false;
          if (!data.isLoadChildren) {
            this.loadReportSummaryAsync(params);
          }
          const rows = res.data.data ? res.data.data : [];
          if (params.level !== 'asset') {
            enrichRowsOwnerInfo(rows, 'google');
          }
          return rows;
        })
        .catch(() => {
          this.tableLoading = false;
          return [];
        });
    },
    loadReportSummaryAsync(listParams) {
      const req = JSON.parse(JSON.stringify(listParams));
      delete req.page;
      delete req.page_length;
      delete req.paged;
      delete req.refreshIdList;
      delete req.after;
      getAdsReportSummary(req)
        .then((res) => {
          if (res.code != 0 || !res.data || !res.data.summary) {
            return;
          }
          const totalCount = this.summary.total_count;
          const currency = this.summary.currency;
          this.summary = {
            ...res.data.summary,
            total_count: totalCount,
            currency: res.data.summary.currency || currency || '$',
          };
          this.summaryMetricsReady = true;
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.doLayout();
            }
          });
        })
        .catch(() => {});
    },
    onCreateSuccess() {
      this.reloadTable({ refreshIdList: true });
    },
    setRelateGoods(data) {
      console.log(data, 'setRelateGoodsdata');
      console.log(this.$store.getters.accountId, 'this.$store.getters.accountId', this.accountId);
      let params = {
        user_id: this.$store.state.user.userInfo.data.id,
        platform: 'google',
        account_id: this.accountId.toString(),
        campaign_id: data.campaign_id,
        campaign_name: data.name,
        route: 'assist',
      };
      console.log(params);
      bindAuto(params).then((res) => {
        if (res.code == 0) {
          data.campaign_ref = 'REF';
        } else {
          data.campaign_ref = 'NOT_REF';
        }
      });
    },
    // 异步加载本地订单数据
    async loadLocalOrderData(dataList, lastParams) {
      if (!dataList || dataList.length === 0) return;
      // asset 层级不需要加载本地订单数据
      if (this.level === 'asset') return;

      try {
        // 后端需要每个组id对应的系列id
        let adsetCmapaignIdMap = null;
        if (lastParams.level === 'adset') {
          adsetCmapaignIdMap = {};
          dataList.forEach((item) => {
            if (item.group_id && item.campaign_id) {
              adsetCmapaignIdMap[item.group_id] = item.campaign_id;
            }
          });
        }
        const adIds = dataList.map((item) => item.id);
        const localOrderParams = {
          ids: adIds,
          actId: Array.isArray(this.accountId) && this.accountId.length > 0 ? this.accountId[0] : null,
          level: lastParams.level,
          platform: 'google',
          dateStart: lastParams.date_start,
          dateEnd: lastParams.date_end,
          adsetCmapaignIdMap,
        };
        console.log('wcpp--------localOrderParams', localOrderParams);
        console.log('wcpp--------accountId', this.accountId);
        const localOrderRes = await getLocalOrderRangeStat(localOrderParams);
        console.log('wcpp-----localorderres', localOrderRes);
        console.log('wcpp-----datalist-0100', dataList);
        if (localOrderRes.code === 0 && localOrderRes.data) {
          for (let key in localOrderRes.data) {
            const findIndex = dataList.findIndex((item) => Number(item.id) === Number(key));
            // console.log('wcpp--findIndex', findIndex)
            if (findIndex !== -1) {
              // 使用 $set 确保响应式更新1
              this.$set(dataList[findIndex], 'local_order', localOrderRes.data[key]);
              this.$set(dataList[findIndex], '_localOrderLoading', false);
              // 更新本地订单数量用于排序
              this.$set(dataList[findIndex], 'localsOrderNum', localOrderRes.data[key]?.orderCount || 0);
              // console.log('wcpp--datalist', dataList)
            }
          }
        }

        // 确保所有项都关闭 loading
        dataList.forEach((item) => {
          if (item && item._localOrderLoading !== false) {
            this.$set(item, '_localOrderLoading', false);
          }
        });
      } catch (error) {
        console.error('获取本地订单error：', error);
        dataList.forEach((item) => {
          if (item) {
            this.$set(item, '_localOrderLoading', false);
          }
        });
      }
    },
    // 格式化本地订单成本
    formatLocalOrderCost(row) {
      if (!row.spend || !row.local_order) return '--';

      const currencySign = row.currency || '$';
      const spend = row.spend;
      const validOrderCount = row.local_order.validOrderCount;
      const orderCount = row.local_order.orderCount;

      if (!validOrderCount || !orderCount) return '--';

      const costPerValid = (spend / validOrderCount).toFixed(1);
      const costPerTotal = (spend / orderCount).toFixed(1);

      return `${currencySign}${costPerValid}/${currencySign}${costPerTotal}`;
    },
    // 列宽
    columnWidth(item) {
      return item.filedKey == 'budget'
        ? '200'
        : item.filedKey == 'local_order'
        ? '140'
        : item.filedKey == 'local_event'
        ? '200'
        : item.filedKey == 'open_schedule'
        ? '260'
        : item.filedName.length >= 8
        ? '180'
        : item.filedName.length >= 5
        ? '110'
        : item.width > 80
        ? item.width
        : '120';
    },
    openAiSuggestion(row) {
      if (!row.hasRecommend) {
        return;
      }
      this.googleTableRow = row;
      if (row.primary_status.includes('BUDGET')) {
        this.budgetSuggestionVisible = true;
      }
      if (row.primary_status.includes('BIDDING')) {
        this.bidSuggestionVisible = true;
      }
    },
    closeBudgetSuggetion() {
      this.budgetSuggestionVisible = false;
    },
    closeBidSuggetion() {
      this.bidSuggestionVisible = false;
    },

    // 定时开启关闭
    async setClockTime(setTimeType) {
      if (!(await guardOwner(this.selectedRowScopes))) return;
      this.setTimeType = setTimeType;
      console.log(this.$refs.setTimeVue);
      this.$refs.setTimeVue.show();
    },
    // 定时设置完成
    // 设置定时时间
    settingComplete(form, type, id, budgetAmount, taskId, data) {
      this.tableData.forEach((item, index) => {
        if (item.id == id) {
          // 确保open_schedule结构存在
          if (!item.open_schedule) {
            item.open_schedule = {
              schedules: [],
              hasSchedule: false,
            };
          }

          let openSchedule = item.open_schedule.schedules || [];

          // 添加新的定时任务
          openSchedule.push({
            id: taskId,
            adId: id,
            type: type,
            timeStr: form.dateVal,
            budget: budgetAmount ? budgetAmount : null,
            lifetimeBudget: type === 2 && item.budget_type === 'LIFETIME' ? budgetAmount : null,
            dailyBudget: type === 2 && item.budget_type === 'DAILY' ? budgetAmount : null,
            increaseBidAmount: null,
            bidAmount: type !== 2 ? budgetAmount : null,
            status: null,
            ...data,
          });

          // 更新item的open_schedule结构
          item.open_schedule = {
            schedules: openSchedule,
            hasSchedule: true,
          };

          console.log(item, 'item open_schedule');
          this.$set(this.tableData, index, item);
        }
      });
    },
    setCurrentRow(row, index) {
      this.$set(this.tableData, index, row);
    },
    operationLog(data) {
      console.log('aaaaaaaaaaaaaaaaaa', data);
      this.operationData = data.row;
      this.showLog = true;
    },
    // 查询AB品数据
    async queryAbSaleData() {
      if (this.level !== 'campaign' || !this.tableData.length) return;

      const campaignIds = this.tableData.map((item) => item.campaign_id).filter(Boolean);
      if (!campaignIds.length) return;

      this.abSaleLoading = true;
      try {
        const res = await queryAbSaleList({ campaignIds, platform: 'google' });
        if (res.code === 0 && res.data && Array.isArray(res.data)) {
          // 将数组转换为以campaign_id为key的map
          this.abSaleMap = res.data.reduce((map, item) => {
            map[item.campaignId] = item;
            return map;
          }, {});
        }
      } catch (error) {
        console.error('查询AB品数据失败:', error);
      } finally {
        this.abSaleLoading = false;
      }
    },
    // 处理编辑广告组成功后的逻辑
    handleEditAdgroupSuccess() {
      // 如果受众看板是显示状态，则刷新受众看板
      // if (this.audienceCardShow) {
      //   this.$refs.audienceDashboard?.refreshData();
      // }
    },
  },
};
</script>

<style lang="scss">
.alignLeft {
  text-align: left;
  display: block;
}
.rule-tip {
  .rule-score-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.color9 {
  color: #999;
  font-size: 12px;
}
.ACTIVE {
  background: #67c23a;
}

.PAUSED,
.IN_PROCESS {
  background: #e6a23c;
}
.nameDELETED,
.nameARCHIVED {
  @extend .color9;
}

.DELETED {
  background: #f56c6c;
}

.DISAPPROVED {
  background: #ff0000;
}
.PREAPPROVED,
.ARCHIVED {
  background: #409eff;
}

.DELETED,
.WITH_ISSUES,
.PENDING_BILLING_INFO,
.ADSET_PAUSED {
  background: #f56c6c;
}

.PENDING_REVIEW,
.CAMPAIGN_PAUSED {
  background: #909399;
}

.adManagement-container .el-tabs__content {
  padding: 0;
}
.el-icon-info {
  color: #999;
  margin-left: 10px;
}
.el-icon-warning {
  color: #e6a23c;
}
.el-icon-error {
  color: #f56c6c;
}
.adManagement-container {
  .el-table .caret-wrapper {
    width: 0;
  }
}

.toolsCheckTips {
  .el-checkbox,
  .el-radio {
    line-height: 36px;
  }
}

.dropselect {
  .el-select-dropdown__item {
    padding: 0;

    span {
      display: block;
      padding: 0 20px;
    }
  }
}

.el-table__body-wrapper {
  &::-webkit-scrollbar {
    height: 12px;
    width: 12px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}

.statusWarp {
  display: flex;
  align-items: center;
  height: auto;

  .pointer {
    flex: 8px 0 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
}

.breakdownList {
  li {
    line-height: 26px;
  }
}

.cusFilter {
  padding: 0 10px 0 20px;

  .cusFilterList {
    .cusFilterItem {
      margin-bottom: 10px;
    }
  }
}

.el-dropdown-menu__item {
  &.active {
    background: #ecf5ff;
    color: #66b1ff;
  }

  .columnName {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      p {
        display: block;
      }
    }

    div {
      p {
        flex: 60px 0 0;
        display: none;

        i {
          margin: 0 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
}

.tagInput {
  width: 30px;

  input {
    width: auto;
    border: none;
    outline: none;
    background: transparent;
    padding: 0 5px;
    width: 30px;
    border-bottom: 1px dashed #fff;
    color: #fff;
    height: 18px;
    line-height: 18px;
  }
}

.el-popover {
  min-width: 100px;
}
.drawerCon {
  height: calc(100vh - 150px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
.tableWrap {
  .el-table .cell {
    line-height: unset;
  }
}
// 状态
.header-status {
  .cell {
    display: flex !important;
    align-items: center;
  }
  .caret-wrapper {
    top: 2px;
  }
}
.reference {
  white-space: nowrap;
}
.my-table.el-table .el-table__body-wrapper {
  /* 预留分页条高度，避免系列/组/广告因固定列+双表头把分页顶出视口 */
  height: calc(100vh - 400px);
  overflow-y: auto;
  overflow-x: overlay;
}
.el-table__fixed-body-wrapper {
  height: calc(100vh - 412px);
  overflow: auto;
}
// .my-table.el-table .el-table__empty-block {
//   height: auto !important;
// }
</style>
<style lang="scss" scoped>
.toolsBar {
  margin: 10px 0;
  background: rgb(232, 241, 255);
  line-height: 32px;
  height: 42.38px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #409eff;
  font-size: 12px;
  .close {
    cursor: pointer;
  }
  .toolsCon {
    display: flex;
    align-items: center;
    i {
      font-size: 16px;
    }
    p {
      background: #409eff;
      line-height: 24px;
      border-radius: 14px;
      padding: 0 10px;
      font-size: 12px;
      color: #fff;
      margin-right: 10px;
    }
  }
}
.tableWrap {
  padding: 16px;
  padding-top: 0;

  .table-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    padding: 8px 0 0;
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    z-index: 10;
    background: #fff;

    .pager-tip {
      color: #909399;
      font-size: 12px;
    }
  }
}
.el-table .caret-wrapper {
  width: 0;
}
.adManagement-container {
  width: 100%;
  height: calc(100vh - 82px);
  background: #fff;

  .el-tabs__item {
    .el-button {
      padding: 4px 10px;
      margin-left: 5px;
    }
  }

  .table-top-bar {
    // position: absolute;
    // top: 56px;
    display: flex;
    align-items: center;
    width: 100%;
    // height: 32px;
    padding: 10px;
    padding-left: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .rightTools {
      flex: 260px 0 0;
      display: flex;
      align-items: center;
      text-align: right;
      justify-content: flex-end;

      .tools {
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .toolsItem {
          margin: 0 4px;
        }
      }

      .searchInput {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .el-button {
          color: #666;
          font-size: 14px;
          margin: 0 5px;
        }
      }
    }

    .midFilter {
      flex: 1;
      padding: 0 10px;
    }

    .table-top-bar-right {
      flex: 1 1 0%;
      display: flex;
      align-items: center;
      position: relative;
      transition: all 0.3s linear 0s;
      // padding-right: 140px;
      .filter-btn {
        display: flex;
        align-items: center;
        height: 32px;
        font-size: 12px;
        color: #8c8c8c;
        margin-left: 12px;
        padding: 0 4px;
        border-radius: 2px;
        transition: all 0.3s linear 0s;
        cursor: pointer;

        img {
          margin-right: 4px;
        }
      }

      .filter-btn:hover {
        background: #eaeaed;
      }

      .filter-operation {
        position: absolute;
        right: 0;
        display: flex;
        align-items: center;
        width: auto;
        padding-left: 10px;
        transition: all 0.3s linear 0s;

        .filter-operation-item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          transition: all 0.3s linear 0s;
          cursor: pointer;

          i {
            color: gray;
          }
        }

        .filter-operation-item:hover {
          background: #eaeaed;
        }
      }
    }
  }
}
// 批量操作的图标去掉直接展示文字
.operate-btn {
  margin-right: 5px;
}
.status-name {
  margin-left: 5px;
}
.bid-status {
  padding: 4px 12px;
  box-sizing: border-box;
  border-radius: 8px;
  background: rgb(254, 247, 224);
  color: rgb(215, 118, 24);
  font-size: 14px;
  margin-top: 3px;
}
.budget-status {
  padding: 4px 12px;
  box-sizing: border-box;
  border-radius: 8px;
  background: rgb(252, 232, 230);
  color: rgb(199, 39, 34);
  font-size: 14px;
}
.common-status {
  margin-left: 5px;
}
</style>
.ab-sale-loading { display: flex; align-items: center; justify-content: center; height: 32px; color: #999; }
.local-order-loading { display: flex; align-items: center; justify-content: center; height: 32px; color: #999; }
.lightColor { color: #bbb; }
